<template>
    <div @click="click($event)" :class="['auto-complete',{'focus': focus}]" ref="inputContainer">
        <input class="present-input"
               type="text"
               :placeholder="placeholder"
               :disabled="disabledData"
               @focus="focus = true"
               v-model="inputValue"
               ref="presentInput"/>

        <div v-show="focus" class="bg-effect" @click="hide()"></div>
        <div v-show="focus && (!second || !selectedSecondItems.length)" ref="firstList" class="input-list">
            <div class="focus-input-wrap">
                <div v-for="(item, key) in selectedItems"
                     :key="key"
                     class="selected-items">
                    <span v-if="item.id === -1">{{localizeList.withoutFlightUpper}}</span>
                    <span v-else>{{item.text}}</span>
                    <svg @click="removeItem(item.id)" class="close-icon">
                        <use xlink:href="../../../assets/images/sprite.svg#close"></use>
                    </svg>
                </div>
                <input class="focus-input"
                       type="text"
                       ref="autoComplateInput"
                       :placeholder="placeholder"
                       @input="searchItem()"
                       v-model="focusInputValue"/>
            </div>
            <div class="shadow-inset"></div>
            <template v-if="searchItems1.length && multiply">
                <p v-if="items1 && !focusInputValue && !dataSecond" class="list-title">{{items1.title}}</p>
                <div v-for="(item, key) in searchItems1"
                     :key="`${key}_1`"
                     :class="['list-item',{'hover': keyMove.position === 0}]">
                    <checkbox v-model="item.isChecked"
                              @change="checked(item)"
                              :label="localizeList.withoutFlightUpper"/>
                </div>
            </template>
            <p v-if="items2 && !focusInputValue" class="list-title">{{localizeList.allOptions}}</p>
            <div v-for="(item, key) in searchItems2"
                 :key="key"
                 @mouseover="mouseHover = true"
                 @mouseout="mouseHover = false"
                 :class="['list-item',{'hover': (keyMove.position === key + 1 && showCities)
                                        || cashSelectedSecondItem && item.id === cashSelectedSecondItem.id && !showCities && !mouseHover}]">
                <checkbox v-model="item.isChecked"
                          @change="checked(item)"
                          v-if="!dataSecond && multiply"
                          :label="item.text"/>
                <p @click="checkedSecond(item)" class="list-item-text" v-else>{{item.text}}</p>
            </div>
        </div>

        <div class="input-list" ref="secondList" v-show="focus && (second && selectedSecondItems.length)">
            <div class="focus-input-wrap">
                <div v-for="(item, key) in selectedSecondItems"
                     :key="key"
                     :class="['selected-items',{'green': second && key === 0}]">
                    <span v-if="item.id === -1">{{localizeList.allUpper}}</span>
                    <span v-else>{{item.text}}</span>
                    <svg @click="removeItem(item.id, true, key)" class="close-icon">
                        <use xlink:href="../../../assets/images/sprite.svg#close"></use>
                    </svg>
                </div>
                <input class="focus-input"
                       type="text"
                       ref="secondAutoComplateInput"
                       :placeholder="placeholder"
                       @input="searchSecondItem()"
                       v-model="focusInputSecondValue"/>
            </div>
            <template v-if="showCities">
                <div class="shadow-inset"></div>
                <div v-for="(item, key) in searchSecondItems"
                     :key="key"
                     :class="['list-item',{'hover': keyMove.position === key}]">
                    <checkbox v-model="item.isChecked"
                              @change="checkedSecond(item)"
                              :label="getLabel(item)"/>
                </div>
            </template>
            <template v-else>
                <div class="shadow-inset"></div>
                <div class="list-item">
                  <p class="list-item-subtext">{{ localizeList.youCanSelectOnlyItem }}</p>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
    import * as methods from "@/plugins/methods.js"

    export default {
        name: "auto-complete",
        data() {
            return {
                inputValue: "",
                focusInputValue: "",
                focusInputSecondValue: "",
                focus: false,
                dataSecond: false,
                disabledData: false,
                searchItems1: [],
                searchItems2: [],
                searchSecondItems: [],
                selectedItems: [],
                selectedSecondItems: [],
                citiesToStatus: true,
                keyMove: {
                    position: 1,
                },
                defaultValueSettings: false,
                cashSelectedSecondItem: {},
                mouseHover : false
            }
        },
        props: {
            secondItems: {
                type: Array,
                default: () => []
            },
            placeholder: {
                type: String,
                default: "text"
            },
            value: {
                type: [String, Number, Array],
                default: ""
            },
            second: {
                type: Boolean,
                default: false
            },
            multiply: {
                type: Boolean,
                default: false
            },
            showCities: {
                type: Boolean,
                default: true
            },
            items1: {
                type: Object,
                default: null
            },
            items2: {
                type: Object,
                default: null
            },
            disabled: {
                type: Boolean,
                default: false
            },
            focusFromParent: {
                type: Boolean,
                default: false
            },

        },
        mounted() {
            window.addEventListener('keydown', this.keyDown);
            this.disabledData = this.disabled;
            this.dataSecond = this.second;
            if (this.items1) {
                this.searchItems1 = this.items1.items
            }
            if (this.items2) {
                this.searchItems2 = this.items2.items;
            }

            this.defaultValueSettings = !!window.settings.destCities?.length
        },
        methods: {
            getInputTextValue(text) {
              const presentInput = getComputedStyle(this.$refs.presentInput);
              const padding = parseInt(presentInput.paddingLeft) + parseInt(presentInput.paddingRight);

              const containerWidth = this.$refs.inputContainer.clientWidth - padding;
              let totalWidth = 0;
              let visibleWords = [];
              for (let i = 0; i < text.length; i++) {
                if (i === 0) {
                  totalWidth = this.getTextWidth(text[i] + " –", '16px Roboto');
                  continue;
                }
                // Получаем ширину текущего слова
                const wordWidth = this.getTextWidth(text[i] + ",", '16px Roboto');
                // Проверяем, уместится ли слово в контейнер
                if (totalWidth + wordWidth <= containerWidth) {
                  if (i === 1) {
                    visibleWords.push(text[i]);
                  } else {
                    visibleWords.push(' ' + text[i]);
                  }
                  totalWidth += wordWidth;
                } else {
                  // Если слово не умещается, помечаем оставшиеся как "+N"
                  const remainingWordsCount = text.length - i;
                  visibleWords.push(`+${remainingWordsCount}`);
                  break;
                }
              }
              visibleWords = visibleWords.join(',');
              const inputValue = text.length > 2 ? `${text[0] + " –"} ${visibleWords}` : text.join(" – ")

              return inputValue
            },
            getTextWidth(text, font) {
              const canvas = document.createElement('canvas');
              const context = canvas.getContext('2d');
              context.font = font;
              const metrics = context.measureText(text);
              return metrics.width;
            },
            keyDown(e) {
                if (e.keyCode === 9) {
                    this.hide()
                }

                if (!this.focus) {
                    return
                }
                if (e.keyCode === 40) {
                    if (this.second && this.dataSecond || !this.second) {
                        if (this.keyMove.position < this.searchItems2.length) {
                            this.keyMove.position++
                        }
                    } else if (this.second && !this.dataSecond) {
                        if (this.keyMove.position < this.secondItems.length - 1) {
                            this.keyMove.position++
                        }
                    }
                    if (this.$refs.firstList.scrollBy && (this.second && this.dataSecond || !this.second)) {
                        this.$refs.firstList.scrollBy(0, 20)
                    } else if (this.$refs.secondList.scrollBy && (this.second && !this.dataSecond)) {
                        this.$refs.secondList.scrollBy(0, 20)
                    }
                }
                if (e.keyCode === 38) {
                    if (this.keyMove.position > 0) {
                        this.keyMove.position--
                    }
                    if (this.$refs.firstList.scrollBy && (this.second && this.dataSecond || !this.second)) {
                        this.$refs.firstList.scrollBy(0, -20)
                    } else if (this.$refs.secondList.scrollBy && (this.second && !this.dataSecond)) {
                        this.$refs.secondList.scrollBy(0, -20)
                    }
                }
                if (e.keyCode === 13 && this.focus) {
                    let item = null;
                    if (!this.second) {
                        if (this.keyMove.position === 0) {
                            item = this.searchItems1[0];
                            if (!item) return;

                            this.checked(item);
                            if (item.isChecked) {
                                this.searchItems1[0].isChecked = false
                            }
                        } else {
                            item = this.searchItems2[this.keyMove.position - 1];
                            if (!item) return;

                            this.checked(item);
                            if (item.isChecked) {
                                this.searchItems2[this.keyMove.position - 1].isChecked = false
                            }
                        }
                    } else {
                        // if (this.dataSecond) {
                        //     item = this.searchItems2[this.keyMove.position - 1];
                        //     this.checkedSecond(item);
                        // } else {
                        //     item = this.searchSecondItems[this.keyMove.position];
                        //     this.checkedSecond(item);
                        //     setTimeout(() => {
                        //         let newItem = Object.assign({}, this.searchSecondItems[this.keyMove.position]);
                        //         if (item.isChecked) {
                        //             newItem.isChecked = false;
                        //         } else {
                        //             newItem.isChecked = true;
                        //         }
                        //         this.$set(this.searchSecondItems, this.keyMove.position, newItem);
                        //     }, 0)
                        // }
                    }
                }
            },
            getLabel(item) {
                if (item.id === -1) {
                    item.text = this.localizeList.allUpper
                }
                return item.text
            },
            checked(item) {
                if (!item.isChecked) {
                    this.selectedItems.push(item);
                    this.selectedItems = this.$store.getters['quicksort'](this.selectedItems, "text")
                } else {
                    this.selectedItems = this.selectedItems.filter(x => x.id !== item.id)
                }
                this.$emit("change", this.selectedItems);
                this.$emit("input", this.selectedItems.map(x => x.id));

                if (!this.showCities) this.hide();
            },
            checkedSecond(item) {
                if (this.multiply) {
                    let index = this.selectedSecondItems.map(x => x.id).indexOf(item.id);
                    let hasItemAll = this.selectedSecondItems.map(x => x.id).includes(-1);
                    if (item && !item.isChecked) {
                        if (!this.selectedSecondItems.length) {
                            this.citiesToStatus = true
                        }
                        if (item.id === -1) {
                            this.selectedAllSecondItems()
                        } else {
                            const selectedAll = this.selectedSecondItems.some(x => x.id === -1);
                            if (selectedAll) this.removeItem(-1, true, 1);
                            this.selectedSecondItems.push(item);

                            // let isSelectedAllSecondItems = this.searchSecondItems.length === this.selectedSecondItems.length
                            // if (isSelectedAllSecondItems) {
                            //     this.selectedAllSecondItems()
                            // }
                        }
                    } else {
                        this.citiesToStatus = false;
                        this.selectedSecondItems.splice(index, 1)

                        if (item && item.id === -1) {
                            this.unSelectedAllSecondItems(-1)
                        } else if (hasItemAll) {
                            this.unSelectedSecondItemAll()

                            this.searchSecondItems.forEach(x => {
                                let include = this.selectedSecondItems.includes(x)
                                if (x.isChecked && !include && x.id !== item.id) {
                                    this.selectedSecondItems.push(x);
                                }
                            })
                        }
                    }
                } else {
                    this.selectedItems = [item];
                    this.hide()
                }
                if (this.focus) {
                    this.$emit("change", this.selectedSecondItems)
                }

                this.$nextTick(() => {
                    if (!this.showCities) this.hide();
                })
            },
            selectedAllSecondItems() {
                this.selectedSecondItems = [this.selectedSecondItems[0]]
                setTimeout(() => {
                    this.searchSecondItems = this.searchSecondItems.map(x => {
                        if (this.value.length > 1 && this.defaultValueSettings) {
                            // делаем выбор для настройки по умолчанию
                            if (this.value.includes(x.id) && !this.selectedSecondItems.map(x2 => x2.id).includes(x.id)) {
                                this.selectedSecondItems.push(x);
                                x.isChecked = true;
                            }
                        } else {
                            // if (x.id === -1 && !this.selectedSecondItems.map(x2 => x2.id).includes(x.id)) {
                            //     this.selectedSecondItems.push(x);
                            // }
                            // x.isChecked = true;
                            if (x.id === -1) {
                                this.selectedSecondItems.push(x);
                                x.isChecked = true;
                            }
                        }

                        return x
                    });
                    this.defaultValueSettings = false;
                    this.$emit("change", this.selectedSecondItems)
                }, 0)
            },
            unSelectedAllSecondItems(id) {
                this.selectedSecondItems = this.selectedSecondItems.filter((x, i) => i === 0)

                this.searchSecondItems = this.searchSecondItems.map(x => {
                    if (x.id !== id)
                        x.isChecked = false;
                    return x
                })
                this.searchItems2 = this.searchItems2.map(x => {
                    if (x.id !== id)
                        x.isChecked = false;
                    return x
                })
            },
            unSelectedSecondItemAll() {
                this.selectedSecondItems = this.selectedSecondItems.filter(x => x.id !== -1)

                this.searchSecondItems = this.searchSecondItems.map(x => {
                    if (x.id === -1)
                        x.isChecked = false;
                    return x
                })
                this.searchItems2 = this.searchItems2.map(x => {
                    if (x.id === -1)
                        x.isChecked = false;
                    return x
                })
            },
            click(e) {
                this.$emit("click", e)
                // Закомментировал, т.к. просили убрать функционал фокуса на начало списка при каждом клике по городу.
                // setTimeout(() => {
                //     if (!this.disabledData) {
                //         if (this.second && !this.dataSecond) {
                //             this.$refs.secondAutoComplateInput.focus()
                //         } else {
                //             this.$refs.autoComplateInput.focus()
                //         }
                //     }
                // }, 500)
            },
            searchItem() {
                let searchText = this.focusInputValue;

                if (this.items1) {
                    this.searchItems1 = this.items1.items
                        .filter(x => x.text.toLowerCase().includes(searchText.toLowerCase()))
                        .map(x => {
                            this.selectedItems.forEach(x2 => {
                                if (x.id === x2.id) {
                                    x.isChecked = x2.isChecked
                                }
                            })
                            return x
                        })
                }
                if (this.items2) {
                    this.searchItems2 = this.items2.items
                        .filter(x => x.text.toLowerCase().includes(searchText.toLowerCase()))
                        .map(x => {
                            this.selectedItems.forEach(x2 => {
                                if (x.id === x2.id) {
                                    x.isChecked = x2.isChecked
                                }
                            })
                            return x
                        })
                }
            },
            searchSecondItem() {
                let searchText = this.focusInputSecondValue;

                this.searchSecondItems = this.secondItems.filter(x => x.text.toLowerCase().includes(searchText.toLowerCase()))
                    .map(x => {
                        this.selectedSecondItems.forEach(x2 => {
                            if (x.id === x2.id) {
                                x.isChecked = x2.isChecked
                            }
                        })
                        return x
                    })
            },
            removeItem(id, second = false, key) {
                if (second) {
                    if (key === 0) {
                        this.selectedSecondItems = []
                        this.searchSecondItems = this.searchSecondItems.map(x => {
                            x.isChecked = false
                            return x
                        })
                        this.searchItems2 = this.searchItems2.map(x => {
                            x.isChecked = false
                            return x
                        })
                        this.dataSecond = true;
                    } else {
                        if (id === -1) {
                            this.searchSecondItems = this.searchSecondItems.map(x => {
                                x.isChecked = false;
                                return x
                            });
                            this.citiesToStatus = false
                        } else {
                            let index = this.selectedSecondItems.map(x => x.id).indexOf(id)
                            if (index !== -1) this.selectedSecondItems.splice(index, 1)

                            this.searchSecondItems = this.searchSecondItems.filter(val => {
                                if (val.id === id)
                                    val.isChecked = !val.isChecked
                                return val
                            })
                        }
                    }
                    this.unSelectedSecondItemAll()

                } else {
                    if (this.items1) {
                        this.items1.items = this.items1.items.map(val => {
                            if (val.id === id)
                                val.isChecked = !val.isChecked
                            return val
                        });
                    }
                    if (this.items2) {
                        this.items2.items = this.items2.items.map(val => {
                            if (val.id === id)
                                val.isChecked = !val.isChecked
                            return val
                        });
                    }
                    this.selectedItems = this.selectedItems.filter(x => x.id !== id)
                    this.$emit("change", this.selectedItems)
                    this.$emit("input", this.selectedItems.map(x => x.id))
                }
            },
            hide() {
                if (!this.showCities && !this.selectedSecondItems.length) {
                  this.selectedSecondItems = [this.cashSelectedSecondItem];
                }

                if (this.second) {
                    this.$emit("input", this.selectedSecondItems.map(x => x.id))
                } else {
                    this.$emit("input", this.selectedItems.map(x => x.id))
                }
                this.focus = false;
                this.$emit("blur")
            }
        },
        updated() {
            if (this.focus) {
                this.click(true)
            }
        },
        beforeDestroy() {
            window.removeEventListener('keydown', this.keyDown);
        },
        watch: {
            focusFromParent(val) {
                if (val) {
                    this.focus = true
                }
            },
            localizeList: {
                deep: true,
                handler() {
                    if (this.second) {
                        let texts = this.selectedSecondItems.map(x => {
                            if (x.id === -1) {
                                x.text = this.localizeList.allUpper
                            }
                            return x.text
                        });
                        if (texts.length > 2) {
                            this.inputValue = this.getInputTextValue(texts)
                        } else {
                            this.inputValue = texts.join(" – ")
                        }
                    }
                }
            },
            disabled(val) {
                this.disabledData = val
            },
            value(val, oldVal) {
                let isRepeat = true;
                if (val) {
                    val.forEach(x => {
                        if (!oldVal.includes(x)) {
                            isRepeat = false
                        }
                    })
                }
                if (!isRepeat || !val.length) {
                    if (val !== oldVal && !val.length && oldVal.length && this.second && typeof val != "string") {
                        this.removeItem(null, true, 0)
                    }
                    if (val && this.focus && this.second) {
                        let cashTo = JSON.parse(methods.getCookieValueByName("hotelsTourTo"));
                        if (!cashTo || cashTo && cashTo != val) {
                            document.cookie = `hotelsTourTo=${JSON.stringify(val)}; path=/`;
                        }
                    }
                    if (val && !this.focus) {
                        if (this.second) {
                            let localVal = [];
                            let itemsCountries = [];
                            let itemsCities = [];
                            this.searchItems2.forEach(x => {
                                itemsCountries.push(x)
                            });
                            this.secondItems.forEach(x => {
                                itemsCities.push(x);
                            });
                            itemsCountries.filter(x => {
                                if (val[0] === x.id && !localVal.map(x3 => x3.id).includes(x.id)) {
                                    localVal.push(x)
                                }
                            });
                            itemsCities.filter(x => {
                                val.slice(1).forEach(x2 => {
                                    if (x2 === x.id && !localVal.map(x3 => x3.id).includes(x.id)) {
                                        localVal.push(x)
                                    }
                                });
                            });
                            let text = localVal.map(x => x.text)
                            this.inputValue = this.getInputTextValue(text)
                            if (this.showCities && localVal.length !== 1) {
                                let helper = true;
                                localVal.forEach(x => {
                                    if (this.selectedSecondItems.map(x2 => x2.id).includes(x)) {
                                        helper = false
                                    }
                                });
                                if (helper && localVal[0]) {
                                    this.selectedSecondItems = [...localVal].map(x => {
                                        x.isChecked = true;
                                        return x
                                    })
                                } else {
                                    this.searchSecondItems = this.searchSecondItems.map(x => {
                                        if (localVal.map(x2 => x2.id).includes(x.id)) {
                                            x.isChecked = true
                                        }
                                        return x
                                    })
                                }
                            } else if (localVal[0]) {
                                this.selectedSecondItems = [localVal[0]]
                            }
                        } else {
                            let localVal = [];
                            let items = [];
                            this.searchItems1.forEach(x => {
                                items.push(x);
                            });
                            this.searchItems2.forEach(x => {
                                items.push(x);
                            });
                            items.forEach(x => {
                                if (val.includes(x.id)) {
                                    localVal.push(x);
                                }
                            });
                            if (localVal.length && val != oldVal) {
                                this.selectedItems = localVal.slice();
                            }
                        }
                    }
                }
            },
            'items1.items': {
                deep: true,
                handler(val) {
                    let set = new Set(val)
                    this.searchItems1 = Array.from(set).map(x => {
                        if (this.selectedItems.map(x2 => x2.id).includes(x.id)) {
                            x.isChecked = true
                        }
                        return x
                    });
                }
            },
            'items2.items': {
                deep: true,
                handler(val) {
                    let set = new Set(val)
                    this.searchItems2 = Array.from(set).map(x => {
                        if (this.selectedItems.map(x2 => x2.id).includes(x.id)) {
                            x.isChecked = true
                        }
                        return x
                    });

                    this.cashSelectedSecondItem = this.searchItems2[0] || {}
                }
            },
            secondItems: {
                deep: true,
                handler(val, oldVal) {
                    let isRepeat = true;
                    if (val) {
                        val.forEach(x => {
                            if (!oldVal.includes(x)) {
                                isRepeat = false
                            }
                        })
                    }
                    if (isRepeat) return;

                    if (this.showCities) {
                        let set = new Set(val)
                        this.searchSecondItems = Array.from(set);
                        if (this.selectedSecondItems.length === 1 && this.focus && this.citiesToStatus) {
                            this.selectedAllSecondItems();
                            this.keyMove.position = 1
                        } else if (this.selectedSecondItems.length === 2 && this.selectedSecondItems[1].id === -1) {
                            // this.searchSecondItems = this.searchSecondItems.map(x => {
                            //     x.isChecked = true;
                            //     return x
                            // })
                            this.searchSecondItems = this.searchSecondItems.map(x => {
                                x.isChecked = x.id === -1;
                                return x
                            });
                            document.cookie = `tourTo=${JSON.stringify(this.selectedSecondItems.map(x => x.id))}; path=/`;
                            // localStorage.setItem("tourTo", JSON.stringify(this.selectedSecondItems.map(x => x.id)))
                            this.$emit("input", this.selectedSecondItems.map(x => x.id))
                        } else if (this.selectedSecondItems.length) {
                            this.selectedSecondItems.forEach((x, i) => {
                                if (i !== 0 && !this.searchSecondItems.map(x2 => x2.id).includes(x.id)) {
                                    this.selectedSecondItems = this.selectedSecondItems.filter(x2 => x2.id !== x.id)
                                }
                            })
                            this.searchSecondItems = this.searchSecondItems.map(x => {
                                if (this.selectedSecondItems.map(x2 => x2.id).includes(x.id)) {
                                    x.isChecked = true
                                }
                                return x
                            })
                            if (this.selectedSecondItems.length === 1 && this.citiesToStatus) {
                                this.selectedAllSecondItems()
                            }
                        }
                    }
                }
            },
            focus(val) {
                if (!this.showCities && this.selectedSecondItems.length && val) {
                    this.cashSelectedSecondItem = this.selectedSecondItems[0];
                    this.selectedSecondItems = [];
                }

                if (val) {
                    this.$emit("focus", true)
                } else {
                    this.$emit("blur", true)
                }
            },
            selectedItems(val, oldVal) {
                if (!this.second) {
                    let texts = val.map(x => {
                        if (x.id === -1) {
                            x.text = this.localizeList.withoutFlightUpper
                        }
                        return x.text
                    });
                    if (texts.length > 2) {
                        this.inputValue = `${texts[0]}, ${texts[1]}, +${texts.length - 2}`
                    } else {
                        this.inputValue = texts.join(", ")
                    }

                    this.focusInputValue = "";
                    this.searchItem();

                    if (!(val[0] && oldVal[0] && val[0].id === oldVal[0].id)) {
                        this.$emit("input", val.map(x => x.id))
                    }

                    this.searchItems1 = this.searchItems1.map(x => {
                        if (this.selectedItems.map(x2 => x2.id).includes(x.id)) {
                            x.isChecked = true
                        }
                        return x
                    });
                    this.searchItems2 = this.searchItems2.map(x => {
                        if (this.selectedItems.map(x2 => x2.id).includes(x.id)) {
                            x.isChecked = true
                        }
                        return x
                    });
                }
            },
            selectedSecondItems(val) {
                if (!this.showCities) {
                    let texts = val.map(x => x.text);
                    this.inputValue = texts.join(" – ");
                    if (val[0]) {
                        this.$emit("input", [val[0].id])
                    }
                }
                if (this.second && this.showCities) {
                    if (val.length === 1) {
                        this.$emit("get-cities", val.slice())
                    }
                    if (val.length >= 1) {
                        this.dataSecond = false
                    }

                    let texts = val.map(x => x.text);
                    if (texts.length > 2) {
                        this.inputValue = this.getInputTextValue(texts)
                    } else {
                        this.inputValue = texts.join(" – ")
                    }
                    this.focusInputSecondValue = "";

                    let allParam = val.find(x => x.id === -1)
                    if (allParam) {
                        this.inputValue = `${texts[0]} – ${allParam.text}`;
                        let res = [val[0], allParam];
                        this.$emit("input", res.map(x => x.id))
                    } else if (val.length > 1) {
                        this.$emit("input", val.map(x => x.id))
                    }
                    if (!val.length) {
                        this.$emit("input", [])
                    }
                    if (val.length < 2) {
                        this.$emit("valid", false)
                    } else {
                        this.$emit("valid", true)
                    }
                    if (val.length === 2 && val[1].id === -1) {
                        this.searchSecondItems = this.searchSecondItems.map(x => {
                            if (x.id === -1)
                                x.isChecked = true;

                            return x
                        })
                    }
                }
            }
        }
    }
</script>

<style scoped>
    .auto-complete {
        position: relative;
    }

    .auto-complete input {
        width: 100%;
        border: none;
        outline: none;
        padding: 8px 40px 8px 12px;
        background-color: var(--lighten-6-color);
        border-radius: 3px;
        font-weight: 500;
        font-size: 16px;
        line-height: 19px;
        color: #333;
    }

    .auto-complete input::placeholder {
        color: var(--lighten-5-color);
    }

    .bg-effect {
        z-index: 100;
    }

    .input-list {
        overflow: auto;
        max-height: 60vh;
        min-width: calc(100% + 20px);
        max-width: 300px;
        position: absolute;
        top: -12px;
        left: -12px;
        z-index: 100;
        background-color: var(--white-color);
        box-shadow: 0 5px 15px rgba(0, 0, 0, .5);
        border-radius: 4px;
    }

    .input-list .focus-input-wrap {
        margin: 12px;
        border: 2px solid var(--primary-color);
        border-radius: 3px;
        padding: 6px 6px 0 6px;
        display: flex;
        flex-wrap: wrap;
    }

    .input-list .focus-input-wrap .selected-items {
        background: var(--primary-color);
        border-radius: 3px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 6px;
        height: 32px;
        margin: 0 4px 4px 0;
    }

    .input-list .focus-input-wrap .selected-items.green {
        background: var(--green-color);
    }

    .input-list .focus-input-wrap .selected-items span {
        font-weight: 500;
        font-size: 14px;
        line-height: 16px;
        color: var(--white-color);
    }

    .input-list .focus-input-wrap .selected-items .close-icon {
        width: 9px;
        height: 9px;
        fill: var(--white-color);
        opacity: .7;
        margin-left: 3px;
        cursor: pointer;
    }

    .input-list .focus-input-wrap .selected-items .close-icon:hover {
        opacity: 1;
    }

    .input-list .focus-input-wrap input {
        background-color: transparent;
        padding: 3px 2px;
        width: 100px;
        margin-bottom: 4px;
    }

    .input-list .list-item /deep/ .c-checkbox{
        padding: 10px 12px;
        transition: all .2s;
        cursor: pointer;
    }

    .input-list .list-item .list-item-text:hover,
    .input-list .list-item /deep/ .c-checkbox:hover,
    .input-list .list-item.hover .list-item-text,
    .input-list .list-item.hover /deep/ .c-checkbox {
        background-color: var(--lighten-1-color);
    }

    .input-list .list-item .list-item-text {
        font-weight: 500;
        font-size: 16px;
        color: var(--dark-1-color);
        margin: 0;
        padding: 10px 12px 10px 24px;
        transition: all .2s;
        cursor: pointer;
    }

    .input-list .list-item .list-item-subtext {
        font-weight: 500;
        font-size: 16px;
        color: var(--dark-1-color);
        margin: 0;
        padding: 12px;
        transition: all .2s;
        cursor: pointer;
        text-align: center;
    }

    .input-list .shadow-inset {
        width: 100%;
        height: 2px;
        box-shadow: 0 3px 5px rgba(100, 100, 100, .1);
    }

    .input-list .list-title {
        font-weight: normal;
        font-size: 15px;
        line-height: 30px;
        color: var(--lighten-5-color);
        border-bottom: 1px solid var(--lighten-4-color);
        padding: 10px;
        margin: 0;
    }
</style>
